export class readablePriceHelper {
    public readablePrice(price:any){
        return Number(price)
            .toFixed(2)               // 2 décimales
            .replace('.', ',')        // si tu veux garder le point, enlève cette ligne
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
}